import { useQuery } from '@tanstack/react-query';
import type { GroupDto } from '@mondy/shared';
import { api } from '@/api';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface MyGroupsResponse {
  groups: GroupDto[];
}

/**
 * Lists the groups the current user belongs to. Cached under
 * `['groups','my']` — membership mutations (create, accept, leave, delete,
 * revoke) should `invalidateQueries({ queryKey: ['groups','my'] })`.
 *
 * Guarded by `useCurrentUser()` so it doesn't fire on unauthenticated pages.
 */
export function useMyGroups() {
  const me = useCurrentUser();
  return useQuery({
    queryKey: ['groups', 'my'] as const,
    queryFn: () => api.get<MyGroupsResponse>('/api/groups/my'),
    enabled: Boolean(me),
    staleTime: 60_000,
  });
}
